export function _(str: string) {
    return str;
}


// WEBPACK FOOTER //
// ./src/app/extract.ts